import FolderSlider from './FolderSlider';
import FolderSliderContainer from './FolderSlider.container';

export default FolderSliderContainer(FolderSlider);
